import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { rootActions } from 'Store';
import {
  DocumentFieldDeletePayload,
  DocumentFieldsCRUDMeta,
} from 'Interfaces/DocumentFields';

export interface DeleteEmbedDocumentField {
  (payload: DocumentFieldDeletePayload, meta?: DocumentFieldsCRUDMeta): void;
}

export default () => {
  const dispatch = useDispatch();

  const deleteEmbedDocumentField: DeleteEmbedDocumentField = useCallback(
    (
      payload: DocumentFieldDeletePayload,
      meta: DocumentFieldsCRUDMeta = { pushToHistory: true },
    ) => {
      dispatch(
        rootActions.documentField.deleteEmbedDocumentField.request({
          payload,
          meta,
        }),
      );
    },
    [dispatch],
  );

  return deleteEmbedDocumentField;
};
